import React from "react";
import ChartSidebarAccordion from "../ChartSidebarAccordion";
import { useSelector } from "react-redux";
import { Typography } from "@material-ui/core";
import useStyles from "../Styles";
import useGeneratedEntityAboutText from "hooks/useGeneratedEntityAboutText";

function ColoradoRiverAccessAboutTab() {
  const { tribe_selected, city_selected, western_arizona_selected, is_tribe, is_city, is_western } =
    useSelector((state) => state.technical_view);
  const classes = useStyles();

  const aboutText = useGeneratedEntityAboutText();

  return (
    <>
      <ChartSidebarAccordion
        group_name={
          //   central_az_tab === "irrigation_district"
          //     ? `Central Arizona ${irrigation_district_selected.name} Water Deliveries`
          //     : `Central Arizona ${city_selected.name} Water Uses`
          "About the Visual"
        }
        accordion_name={'about'}
      >
        <Typography
          variant="body2"
          component="p"
          className={classes.aboutContent}
        >
            <p>This visual shows how access to Colorado River water changes based on the current scenario. </p>

            <p>Tribes, cities, private water companies, irrigation districts, farmers, mines, power companies, and others hold individual entitlements to Colorado River water in Arizona.  There is a priority system that specifies the order in which water users experience cuts during shortage.  Mainstem users in Western Arizona—those who draw their water directly from the Colorado River—generally have high priority rights and are relatively protected against shortages.  Almost all of this water is used for agriculture.  Entities in Maricopa, Pinal, and Pima counties that receive Colorado River water delivered through the Central Arizona Project (CAP) canal face the biggest cuts because they have lower priority rights than most mainstem users.  There is also a priority system among CAP users.  From lowest to highest priority these are:  Excess & Agriculture Pool, Non-Indian Agricultural (NIA), Municipal & Industrial (M&I)/Indian, and Priority 3.  Some entities hold a combination of these priorities.  How entities are impacted by shortage varies depending on the priority of the Colorado River water to which they have access.</p>

        </Typography>
      </ChartSidebarAccordion>
      <ChartSidebarAccordion
        group_name={is_tribe? `Entity: ${tribe_selected.name}` : (is_city? `Entity: ${city_selected.name}` : (is_western ? `Entity: ${western_arizona_selected.name}` : ""))}
        accordion_name={'Entity'}
      >
        <Typography
          variant="body2"
          component="p"
          className={classes.aboutContent}
        >
          {aboutText}
        </Typography>
      </ChartSidebarAccordion>
      {/* <ChartSidebarAccordion
        group_name={
          //   central_az_tab === "irrigation_district"
          //     ? `Entity: ${irrigation_district_selected.name}`
          //     : `Entity: ${city_selected.name}`
          `Scenario`
        }
      >
        <Typography
          variant="body2"
          component="p"
          className={classes.aboutScenarioTitle}
        >
          Name of Scenario
        </Typography>
        <Typography
          variant="body2"
          component="p"
          className={classes.aboutScenario}
        >
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim venia, quis nostrud exercitation ullamco labo is nisi ut aliquip
          ex ea com.
        </Typography>
      </ChartSidebarAccordion> */}
    </>
  );
}

export default ColoradoRiverAccessAboutTab;
